import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useProgramContext } from "./ProgramDataContext";

/**
 * Mark a school program full or not full, the school program twin of the
 * Batches "Mark as Full" dialog. `full` is the value to set. The flag also
 * turns website registration for the program off (a full program is listed
 * as contact-only and checkout refuses it), so the copy says so.
 */
export function ProgramFullDialog({ history, id, full, show, onHide, onResult }) {
  const context = useProgramContext();
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!id) onHide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const save = async () => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      await axios.patch(`api/school-programs/${id}/full`, {
        class_full_ind: full ? 1 : 0,
      });
      onResult && onResult(true, full);
      context.setRefetch(true);
      history.push("/school-programs/program-list");
    } catch (e) {
      const body = e.response && e.response.data;
      onResult && onResult(false, full, body && body.message);
      onHide();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={isSaving ? () => {} : onHide}
      backdrop={isSaving ? "static" : true}
      keyboard={!isSaving}
      aria-labelledby="program-full-title"
    >
      <Modal.Header closeButton={!isSaving}>
        <Modal.Title id="program-full-title">
          {full ? "School Program Full" : "School Program Not Full"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {full ? (
          <span>
            Are you sure you want to mark this program full? It will show as
            full on the portal and the website will stop taking registrations
            for it.
          </span>
        ) : (
          <span>
            Are you sure you want to mark this program as not full? The website
            will take registrations for it again if "Register on website" is
            on.
          </span>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button type="button" onClick={onHide} className="btn btn-light btn-elevate" disabled={isSaving}>
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={save}
            className={`btn btn-elevate ${full ? "btn-danger" : "btn-primary"}`}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : full ? "Mark Full" : "Mark Not Full"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
